import { useCallback } from 'react';
import { useStateIfMounted } from 'use-state-if-mounted';
import lpBondsNfts from 'services/lpBondsNfts';

/**
 * Hook to refresh NFT metadata
 * @returns {Object} { refreshMetadata, isRefreshing }
 */
const useRefreshMetadata = () => {
  const [isRefreshing, setIsRefreshing] = useStateIfMounted(false);

  const refreshMetadata = useCallback(async ({ contractAddress, tokenId }) => {
    if (!contractAddress || !tokenId) {
      return { success: false, message: 'Missing contractAddress or tokenId' };
    }

    setIsRefreshing(true);

    try {
      const response = await lpBondsNfts.refreshMetadata({
        contractAddress,
        tokenId,
      });

      setIsRefreshing(false);

      // Normalize response - API may return { success, message } or just data
      if (response && typeof response.success === 'boolean') {
        return response;
      }

      // If we got here without error, consider it a success
      return { success: true, message: response?.message || 'Metadata refresh requested' };
    } catch (error) {
      console.error('Error refreshing metadata:', error);
      setIsRefreshing(false);
      return { success: false, message: error?.message || 'Failed to refresh metadata' };
    }
  }, []);

  return { refreshMetadata, isRefreshing };
};

export default useRefreshMetadata;
